import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const apiFieldNameMap = {
  descriptionType: 'SiteDescriptionType',
  standingType: 'SiteStandingType',
  timberQuality: 'TimberQuality',
  access: 'Access',
};

const useInfoDropdowns = (fieldNames = []) => {
  const [dropdowns, setDropdowns] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!fieldNames.length) return;

    const fetchDropdowns = async () => {
      setLoading(true);
      setError(null);

      const results = {};

      for (const field of fieldNames) {
        const apiKey = apiFieldNameMap[field] || field;

        try {
          const res = await customAxios.get(`/GenTasks/GetDropdownList/${apiKey}`, {
            headers: authHeader(),
          });

          if (res.status === 200 && Array.isArray(res.data)) {
            results[field] = res.data.map(item => ({
              label: item.keyValue,
              value: item.keyValue,
            }));
          }
        } catch (err) {
          console.error(`❌ Error fetching dropdown for "${field}" using API key "${apiKey}"`, err);
          setError(err);
        }
      }

      setDropdowns(results);
      setLoading(false);
    };

    fetchDropdowns();
  }, [fieldNames.join(',')]);

  return { dropdowns, loading, error };
};

export default useInfoDropdowns;
